// extracted by mini-css-extract-plugin
export var footer = "Testimonials-module--footer--b4c73";
export var grid = "Testimonials-module--grid--a12de";
export var gridItem = "Testimonials-module--gridItem--0488c";